import React from 'react';
import styled, { css } from 'styled-components';

const Servicios = ({ viewServicios }) => {
    return(
        <ServiciosCSS viewServicios = { viewServicios }>
            <h1>COMPAÑIA GESTORA DE INVERSIONES EN BIENES RAÍCES</h1>
            <h2>Somos Empresa Líder a nivel Nacional en Promoción del Turismo, mediante la venta de 
            bienes Raíces, Parcelas proyectadas para ayudar a desarrollar y apoyar el Turismo Regional, Ofrecemos 
            Terrenos en el Club Ecoturístico Flor del Guaviare Ubicado en 
            el municipio de San josé del Guaviare, con Áreas de 4100 mts cuadrados hasta 5900 mts cuadrados, y te lo entregamos con un GLAMPING
            construido en madera para Acampar con tu familia y amigos ó para que Inicies tu proyecto Turístico  Brindando un espacio lleno de armonia, Avistamiento de Fauna Silvestre, deportes acuaticos 
            (Canotaje, Motos de agua, Flyboard, ski, etc.) y tranquilidad, alquilando tu GLAMPING a familiares, amigos y otras personas a nivel Nacional e Internacional.</h2>
        </ServiciosCSS>
    )
}
export default Servicios;

const ServiciosCSS = styled.div`
    position: relative;
    background-color: #fff;
    top: 12%;
    height: 88%;
    z-index:5;
    display: none;
    @media(max-width:1150px) {
        height:100%;
    }
    @media(max-width:1024px) {
        height:120%;
    }
    @media(max-width:768px) {
        height:150%;
    }
    @media(max-width:600px) {
        height:190%;
    }
    @media(max-width:480px) {
        height:300%;
    }
    @media(max-width:320px) {
        height:300%;
    }
    ${props => props.viewServicios === true && css`
        display: block;
    `}
    ${props => props.viewServicios === false && css`
        display: none;
    `}
    h1{
        font-family: widen latin;
        margin-top: 5%;
        color: black;
        opacity:1;
        font-size: 250%;
    }
    h2 {
        font-family: widen latin;
        margin:3%;
        font-size: 200%;
    }
`;